import request from 'graphql-request';
import { ENDPOINT } from '@constants/endpoint';
import { graphql } from '@gql/ai-tools/gql';
import {
  AiToolsQuery,
  AiToolsUserDataAiToolsAccessV2Args,
} from '@gql/ai-tools/graphql';
import { ResponseData } from '@models/common';
import { UserDataModel } from '@models/userData';
import { userDataModel } from '@utils/models/userData';

const query = graphql(/* GraphQL */ `
  query AiTools($currentUserUrl: String!) {
    aiTools {
      userDataAiToolsAccessV2(currentUserUrl: $currentUserUrl) {
        clientHash
        userId
        subscription
        hasUserEverHadSubscription
        useSafeCopywriting
        isProFeatureAvailable
        hasAiToolsAccess
        wordBalance
        wordBalanceTotal
        isSplitEs38751New
        isSplitEs38799New
        isSplitEs38934New
        isSplitEs39088New
        isSplitEs39290New
        isSplitEs39123New
        isAgreeAutoUpgradeEs39123
        isSplitEs39222New
        activeSplitTags
        isTestUser
        firstName
        lastName
        email
        smartCustomerFeedbackKey
        trustpilotBusinessUnitId
        photoSrc
        hasActiveSubscription
        isAppInboxEnabled
        status {
          code
          message
        }
      }
    }
  }
`);

export const userData = async (
  payload?: AiToolsUserDataAiToolsAccessV2Args
): Promise<ResponseData<UserDataModel>> => {
  const response = await request<AiToolsQuery>(
    ENDPOINT.GRAPHQL_EDUSSON_AI_TOOL,
    query,
    payload
  );

  const result = userDataModel(response.aiTools?.userDataAiToolsAccessV2);

  return {
    data: result,
    status: response.aiTools?.userDataAiToolsAccessV2?.status?.code,
    message: response.aiTools?.userDataAiToolsAccessV2?.status?.message,
  };
};
